module.exports = __webpack_public_path__ + "static/media/creditinfo-print-logo.15e8d3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/static/images/creditinfo-print-logo.png
// module id = 391
// module chunks = 0